/** @format */

import { ConstructionOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setClientID } from "../../store/clients";
import { showDeleteModal } from "../../store/stateSlice";
//importing assets
import { showExpenseDetails, showOrdersStatus } from "../../store/stateSlice";
import { DateFormatter } from "../../utilities/helper";
import DeleteModal from "../pops/global modals/deleteModal";

export const RenderDate = ({ data }) => {
  const date = DateFormatter(data);
  return <div> {date}</div>;
};

export const RenderStatus = ({ data }) => {
  const statusObj = {
    completed: "تم",
    incomplete: "لم يتم",
    pending: "قيد الانتظار",
    active: "مغعل",
    inactive: "غير مفعل",
    banned: "محظور",
    تم: "green",
    "لم يتم": "red",
    "قيد الانتظار": "orange",
    "غير مفعل": "red",
    محظور: "red",
    مفعل: "green",
    ملغي: "red",
    مقبول: "orange",
    مرفوض: "red",
  };

  return (
    <p
      className={`status-btn status-btn-table  status-btn--${statusObj[data]}`}>
      {data}
    </p>
  );
};
export const RenderName = ({ data }) => {
  return (
    <div className='table-cell__name'>
      {!!data?.image && (
        <img className='table-cell__name-img' alt='' src={data?.image} />
      )}

      <span>{data.name}</span>
    </div>
  );
};
export const RenderService = ({ data }) => {
  return (
    <div className='table-cell__name'>
      <span>{data}</span>
    </div>
  );
};
export const RenderDetails = ({ data }) => {
  return (
    <div className='table-cell__name'>
      <span>{data}</span>
    </div>
  );
};


export const RenderSetting = ({ data, from, link, location }) => {
  let haveShow = ["S"].includes(from);
  let haveDetails = ["D", "DB", "DN"].includes(from);
  let haveblock = ["DB", "B", "BN"].includes(from);
  let haveNoti = ["N", "DN", "BN"].includes(from);
  //redux
  const dispatch = useDispatch();
  const appStore = useSelector((state) => state.toggleState.value);

  const handelDetails = () => {
    dispatch(showExpenseDetails());
    // dispatch(setId({
    //   id : data.row.id,
    //   data : data.row

    // }))
  };
  const handleOrderHistory = () => {
    dispatch(showOrdersStatus());
  };
  const handleDeleteModal = () => {
    dispatch(showDeleteModal());
    dispatch(setClientID({ id: data.row.id }));
  };
  useEffect(() => {
    if (data.row.orderStatus === "قيد الانتظار") {
      haveNoti = true;
    }
  }, []);

  return (
    <>
      {appStore.deleteModel && <DeleteModal from={location} />}
      <div className='table-cell__setting'>
        {haveDetails &&
          (link ? (
            <Link to={link + data.row.id}>
              <div
                className='table-cell__setting-details'
                onClick={handelDetails}>
                <DetailsIcon />
                <p>تفاصيل</p>
              </div>
            </Link>
          ) : (
            <div
              className='table-cell__setting-details'
              onClick={handelDetails}>
              <DetailsIcon />
              <p>تفاصيل</p>
            </div>
          ))}
        {haveblock && (
          <div
            className='table-cell__setting-block'
            onClick={handleDeleteModal}>
            <DeleteIcon /> <p>حذف</p>
          </div>
        )}
        {haveNoti && (
          <div className='table-cell__setting-details' onClick={handelDetails}>
            <svg
              width='46'
              height='35'
              viewBox='0 0 46 35'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M0.5 4C0.5 1.79086 2.29086 0 4.5 0H41.5C43.7091 0 45.5 1.79086 45.5 4V31C45.5 33.2091 43.7091 35 41.5 35H4.5C2.29086 35 0.5 33.2091 0.5 31V4Z'
                fill='#474747'
              />
              <path
                d='M28.1847 20.7372C28.1199 20.6613 28.0563 20.5854 27.9938 20.5122C27.1352 19.5024 26.6157 18.893 26.6157 16.0345C26.6157 14.5546 26.2515 13.3403 25.5338 12.4296C25.0045 11.7568 24.2891 11.2464 23.3462 10.8692C23.334 10.8627 23.3232 10.8541 23.3142 10.8438C22.975 9.73958 22.0469 9 21.0001 9C19.9533 9 19.0256 9.73958 18.6864 10.8427C18.6774 10.8526 18.6667 10.8609 18.6548 10.8673C16.4543 11.7481 15.3849 13.4378 15.3849 16.0334C15.3849 18.893 14.8662 19.5024 14.0068 20.511C13.9443 20.5843 13.8807 20.6587 13.8159 20.7361C13.6486 20.9323 13.5425 21.171 13.5104 21.424C13.4782 21.677 13.5213 21.9337 13.6344 22.1636C13.8752 22.6569 14.3885 22.9631 14.9743 22.9631H27.0302C27.6133 22.9631 28.123 22.6573 28.3646 22.1663C28.4783 21.9363 28.5217 21.6794 28.4898 21.4261C28.4579 21.1728 28.352 20.9338 28.1847 20.7372ZM21.0001 26C21.5641 25.9996 22.1174 25.8507 22.6015 25.5693C23.0855 25.2878 23.4821 24.8842 23.7493 24.4013C23.7619 24.3782 23.7681 24.3523 23.7674 24.3261C23.7666 24.2999 23.7589 24.2744 23.745 24.252C23.7311 24.2296 23.7115 24.211 23.688 24.1982C23.6646 24.1853 23.6381 24.1785 23.6112 24.1786H18.3898C18.3628 24.1785 18.3363 24.1852 18.3128 24.198C18.2893 24.2108 18.2696 24.2294 18.2557 24.2518C18.2417 24.2742 18.234 24.2998 18.2332 24.326C18.2324 24.3522 18.2386 24.3781 18.2512 24.4013C18.5184 24.8842 18.915 25.2877 19.399 25.5692C19.8829 25.8506 20.4362 25.9995 21.0001 26Z'
                fill='white'
              />
            </svg>
          </div>
        )}
        {haveShow && (
          <div
            className='table-cell__setting-details'
            onClick={handleOrderHistory}>
            <svg
              width='45'
              height='35'
              viewBox='0 0 45 35'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V31C45 33.2091 43.2091 35 41 35H4C1.79086 35 0 33.2091 0 31V4Z'
                fill='#FF8900'
              />
              <path
                d='M25.9974 17.4989C25.9974 19.0877 24.653 20.3757 22.9946 20.3757C21.3362 20.3757 19.9918 19.0877 19.9918 17.4989C19.9918 15.91 21.3362 14.622 22.9946 14.622C24.653 14.622 25.9974 15.91 25.9974 17.4989ZM23 11.5088C21.2829 11.5164 19.5031 11.9344 17.8183 12.7347C16.5673 13.3534 15.3482 14.2263 14.2899 15.3038C13.7701 15.8537 13.1072 16.6501 13 17.4998C13.0127 18.2358 13.8022 19.1443 14.2899 19.6958C15.2823 20.7309 16.4697 21.5795 17.8183 22.2655C19.3895 23.028 21.1285 23.467 23 23.4914C24.7187 23.4837 26.4981 23.0609 28.1811 22.2655C29.4321 21.6468 30.6518 20.7733 31.7101 19.6958C32.2299 19.1459 32.8928 18.3495 33 17.4998C32.9873 16.7638 32.1978 15.8553 31.7101 15.3037C30.7177 14.2686 29.5297 13.4207 28.1811 12.7347C26.6107 11.9728 24.8674 11.5368 23 11.5088ZM22.9987 12.9963C25.6007 12.9963 27.71 15.0128 27.71 17.5004C27.71 19.988 25.6007 22.0046 22.9987 22.0046C20.3968 22.0046 18.2875 19.988 18.2875 17.5004C18.2875 15.0128 20.3968 12.9963 22.9987 12.9963Z'
                fill='white'
              />
            </svg>
          </div>
        )}
      </div>
    </>
  );
};

const DetailsIcon = () => {
  return (
    <svg
      width='20'
      height='13'
      viewBox='0 0 20 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.9974 6.90266C12.9974 8.49151 11.653 9.77953 9.99457 9.77953C8.33617 9.77953 6.99177 8.49151 6.99177 6.90266C6.99177 5.3138 8.33617 4.0258 9.99457 4.0258C11.653 4.02578 12.9974 5.31381 12.9974 6.90266ZM10 0.912598C8.28292 0.920214 6.5031 1.33823 4.81827 2.13855C3.5673 2.75725 2.34817 3.63015 1.2899 4.70756C0.770133 5.25755 0.107183 6.05391 0 6.9036C0.0126667 7.63962 0.802167 8.54808 1.2899 9.09965C2.28228 10.1347 3.46967 10.9833 4.81827 11.6693C6.38945 12.4318 8.12853 12.8708 10 12.8952C11.7187 12.8875 13.4981 12.4647 15.1811 11.6693C16.4321 11.0506 17.6518 10.1771 18.7101 9.09965C19.2299 8.54967 19.8928 7.75328 20 6.9036C19.9873 6.16758 19.1978 5.25908 18.7101 4.70753C17.7177 3.67243 16.5297 2.82455 15.1811 2.13851C13.6107 1.37658 11.8674 0.940581 10 0.912598ZM9.99873 2.40006C12.6007 2.40006 14.71 4.41663 14.71 6.90425C14.71 9.39185 12.6007 11.4084 9.99873 11.4084C7.39675 11.4084 5.28748 9.39183 5.28748 6.90425C5.28748 4.41663 7.39675 2.40006 9.99873 2.40006Z'
        fill='black'
      />
    </svg>
  );
};
export const BlockIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.25 16.5C13.3921 16.5 16.75 13.1421 16.75 9C16.75 4.85786 13.3921 1.5 9.25 1.5C5.10786 1.5 1.75 4.85786 1.75 9C1.75 13.1421 5.10786 16.5 9.25 16.5Z'
        stroke='#DA0000'
        stroke-width='2'
        stroke-miterlimit='10'
      />
      <path
        d='M3.94653 3.69666L14.5533 14.3034'
        stroke='#DA0000'
        stroke-width='2'
        stroke-miterlimit='10'
      />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      style={{ height: "2rem" }}>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0'
      />
    </svg>
  );
};
